var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreshdesk1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32129 4.5C3.32129 3.67157 3.99286 3 4.82129 3H6.82129C7.64972 3 8.32129 3.67157 8.32129 4.5V6.5C8.32129 7.32843 7.64972 8 6.82129 8H4.82129C3.99286 8 3.32129 7.32843 3.32129 6.5V4.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32129 17.5C3.32129 16.6716 3.99286 16 4.82129 16H6.82129C7.64972 16 8.32129 16.6716 8.32129 17.5V19.5C8.32129 20.3284 7.64972 21 6.82129 21H4.82129C3.99286 21 3.32129 20.3284 3.32129 19.5V17.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32107 18.5H21.321M16.321 5.5H8.32107M16.6445 7.67649L7.96973 16.3513",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3213 4.5C16.3213 3.67157 16.9929 3 17.8213 3H19.8213C20.6497 3 21.3213 3.67157 21.3213 4.5V6.5C21.3213 7.32843 20.6497 8 19.8213 8H17.8213C16.9929 8 16.3213 7.32843 16.3213 6.5V4.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3213 21L19.7096 20.0537C20.7841 19.3213 21.3213 18.9551 21.3213 18.5C21.3213 18.0449 20.7841 17.6787 19.7096 16.9463L18.3213 16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreshdesk1);
export default __webpack_public_path__ + "static/media/freshdesk-1.56f2105d0121657c2aef6ff6284c5ff4.svg";
export { ForwardRef as ReactComponent };